export default __webpack_public_path__ + "static/media/icon-menu-master-data-active.a12b6a70.svg";